import React from 'react';
import { Typography, Grid, Box } from '@tq/ui-components';
import { tqc } from '@tq/ui-components/dist/system';

import { useIsMobile } from '@tq/ui-components/dist/hooks';
import { ValueLabelResponse } from 'types';

export type KpiValueCardProps = {
  kpiValues: ValueLabelResponse[];
};

export const KpiValueCard: React.FC<KpiValueCardProps> = ({ kpiValues }) => {
  const isMobile = useIsMobile();

  return (
    <Grid
      gridGap={4}
      gridAutoFlow={isMobile ? 'row' : 'unset'}
      my={4}
      gridTemplateColumns={isMobile ? '1fr' : 'repeat(3, 1fr)'}
      className='kpi-values'
    >
      {kpiValues?.map(({ label, value }) => (
        <Grid key={label} gridGap={4} className='kpi-value'>
          <Box fontSize='60px' lineHeight='60px' className='kpi-value-data'>
            <strong>{value}</strong>
          </Box>
          <Typography>
            <tqc.p>{label}</tqc.p>
          </Typography>
        </Grid>
      ))}
    </Grid>
  );
};
